import mapImg from "../../assets/images/map.png";
import { Formik, Form } from "formik";
import PrimaryButton from "../common/PrimaryButton";
import FormikErrorMessage from "../common/FormikErrorMessage";
import EditorTextArea from "../common/EditorTextArea";
import FormikField from "../common/FormikField";

const Message = () => {
  return (
    <div className="relative w-full lg:w-[80%] z-0 mb-16">
      <div className="flex flex-col gap-4 sm:gap-10 sm:flex-row jost-regular lg:px-0 px-12 justify-between items-center w-full">
        <div className="w-full sm:w-[50%]">
          <div className="py-8 sm:py-12 px-4 sm:px-8 border font-gtAmerica border-white md:border-opacity-20 md:border-black rounded-xl">
            <Formik
              initialValues={{
                firstName: "",
                lastName: "",
                email: "",
                phoneNumber: "",
                query: "",
              }}
              onSubmit={(values, { setSubmitting }) => {
                console.log(values);
                setSubmitting(false);
                alert(`Thank you for subscribing, ${values.firstName}`);
              }}
            >
              {({ isSubmitting }) => (
                <Form className="flex flex-col justify-center w-full h-full">
                  <h1 className="text-2xl sm:text-5xl mb-6">
                    How May <br />
                    <span className="text-2xl sm:text-5xl italic font-eiko-thin text-primary">
                      We Help You!
                    </span>
                  </h1>
                  <div className="mb-8 w-full lg:grid lg:grid-cols-2 gap-4">
                    <div className="w-full">
                      <FormikField
                        type="text"
                        name="firstName"
                        id="firstName"
                        placeholder="Enter your First Name"
                        label="First Name"
                        className="placeholder:text-gray-300 border-b-[2px] w-full h-12"
                        required
                      />
                      <FormikErrorMessage name="firstName" />
                    </div>
                    <div className="w-full">
                      <FormikField
                        type="text"
                        name="lastName"
                        id="lastName"
                        placeholder="Enter Your Last Name"
                        label="Last Name"
                        className="placeholder:text-gray-300 border-b-[2px] w-full h-12"
                        required
                      />
                      <FormikErrorMessage name="lastName" />
                    </div>
                    <div className="w-full">
                      <FormikField
                        type="text"
                        name="email"
                        required
                        id="email"
                        placeholder="email@example.com"
                        className="placeholder:text-gray-300 border-b-[2px] w-full h-12"
                        label="Email"
                      />
                      <FormikErrorMessage name="email" />
                    </div>
                    <div className="w-full">
                      <FormikField
                        type="text"
                        name="phoneNumber"
                        required
                        id="phoneNumber"
                        placeholder="Enter Your Phone Number"
                        className="placeholder:text-gray-300 border-b-[2px] w-full h-12"
                        label="Phone Number"
                      />
                      <FormikErrorMessage name="phoneNumber" />
                    </div>
                    <div className="col-span-2">
                      <EditorTextArea
                        placeholder="Hello there!"
                        name="query"
                        required
                        label="Message"
                        className="placeholder:text-gray-300 border-b-[2px] w-full h-28"
                      />
                      <FormikErrorMessage name="query" />
                    </div>
                  </div>
                  <PrimaryButton
                    type="submit"
                    disabled={isSubmitting}
                    className="bg-primary text-white justify-center"
                  >
                    Send Message
                  </PrimaryButton>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <div className="sm:flex flex-col gap-4 mt-4 md:w-[50%] w-full h-[calc(100vh)] rounded-lg">
          <div className="mapouter relative text-right w-full">
            <div className="gmap_canvas">
              <iframe
                title="map"
                id="gmap_canvas"
                className="overflow-hidden background-none rounded-lg w-full h-[calc(50vh)] lg:h-[calc(98vh)]"
                src="https://maps.google.com/maps?q=636+5th+Ave%2C+New+York&t=&z=13&ie=UTF8&iwloc=&output=embed"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Message;
